module.exports = __webpack_public_path__ + "static/media/worldmap.b014bcba.png";